<template>
  <div>
    <edit-payin-form
      :is-active.sync="isEditing"
      method="put"
      :feeConfiguration="feeConfiguration"
      @changed="feeConfigurationUpdated"
    />

    <v-card>
      <v-card-text>
        <v-row>
          <v-col cols="3">
            <key-value title="Id">
              <span class="small" v-text="feeConfiguration.id"></span>
            </key-value>
            <key-value title="Payin Method Name" :value="feeConfiguration.cash_in_method.name" />
            <key-value title="Payin Method Min" :value="feeConfiguration.cash_in_method.min" />
            <key-value
              title="Payin Method Max"
              :value="feeConfiguration.cash_in_method.max"
              type="none"
            />
          </v-col>
          <v-col cols="3">
            <key-value title="Country" :value="feeConfiguration.country.name" />
            <key-value
              title="Is sending Country"
              :value="feeConfiguration.country.is_sending_country"
            />
            <key-value
              title="Sending Min Amount"
              :value="feeConfiguration.country.sending_min_amount"
            />
            <key-value
              title="Sending Max Amount"
              :value="feeConfiguration.country.sending_max_amount"
            />
            <key-value
              title="Receiving Min Amount"
              :value="feeConfiguration.country.receiving_min_amount"
            />
            <key-value
              title="Receiving Max Amount"
              :value="feeConfiguration.country.receiving_max_amount"
            />
          </v-col>
          <v-col cols="3">
            <key-value title="Fee Type" :value="feeConfiguration.fee_type.name" />
            <key-value
              title="Fee Configuration"
              v-if="feeConfiguration.fee_configuration != null"
              :value="feeConfiguration.fee_configuration.name"
            />
          </v-col>
          <v-col cols="3">
            <h3>Actions</h3>
            <v-btn small icon @click="updateFeeConfiguration">
              <v-icon>mdi-pencil-outline</v-icon>
            </v-btn>
            <v-btn small icon @click="deleteFeeConfiguration">
              <v-icon>mdi-delete</v-icon>
            </v-btn>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </div>
</template>
<script>
import EditPayinForm from "./form.vue";
export default {
  components: { EditPayinForm },
  props: {
    feeConfiguration: {
      required: true,
    },
  },
  data: () => ({
    isEditing: false,
  }),
  methods: {
    updateFeeConfiguration() {
      this.isEditing = true;
    },
    feeConfigurationUpdated({ message }) {
      this.isEditing = false;
      Notify.success(message);
      this.$emit("feeConfigUpdated");
    },
    async deleteFeeConfiguration() {
      await Notify.confirm(`Do you want to archive this value?`).then(() => {
        this.$http
          .delete(
            `api/v1/transactions/feeConfigurations/${this.$route.params.feeConfigurationId}/payinMethodDeposit/${this.feeConfiguration.id}`,
          )
          .then(({ message }) => {
            Notify.success(message);
            this.$router.push({
              name: "deposits.payinmethods.index",
              params: { id: this.$route.params.feeConfigurationId },
            });
          })
          .catch((error) => {
            Notify.errorFromResponse(error, { close: true });
          });
      });
    },
  },
};
</script>
